<script setup>
import { computed } from 'vue';
import { useKeyboardEvents } from 'dashboard/composables/useKeyboardEvents';
import wootConstants from 'dashboard/constants/globals';

const props = defineProps({
  items: {
    type: Array,
    default: () => [],
  },
  activeTab: {
    type: String,
    default: wootConstants.ASSIGNEE_TYPE.ME,
  },
  onChannelSurface: {
    type: Boolean,
    default: false,
  },
  accentColor: {
    type: String,
    default: '',
  },
});

const emit = defineEmits(['chatTabChange']);

const activeTabIndex = computed(() => {
  return props.items.findIndex(item => item.key === props.activeTab);
});

const onTabChange = selectedTabIndex => {
  if (selectedTabIndex >= 0 && selectedTabIndex < props.items.length) {
    const selectedItem = props.items[selectedTabIndex];
    if (selectedItem.key !== props.activeTab) {
      emit('chatTabChange', selectedItem.key);
    }
  }
};

const keyboardEvents = {
  'Alt+KeyN': {
    action: () => {
      if (props.activeTab === wootConstants.ASSIGNEE_TYPE.ALL) {
        onTabChange(0);
      } else {
        const nextIndex = (activeTabIndex.value + 1) % props.items.length;
        onTabChange(nextIndex);
      }
    },
  },
};

useKeyboardEvents(keyboardEvents);
</script>

<template>
  <woot-tabs
    :index="activeTabIndex"
    no-scroll
    :border="!onChannelSurface"
    class="w-full px-0 py-0 [&_ul]:p-0"
    :class="
      onChannelSurface
        ? 'chat-type-tabs--channel min-h-[3.75rem] [&_ul]:gap-1.5 [&_ul]:items-stretch [&_ul]:justify-between'
        : '-mt-1 h-9'
    "
    @change="onTabChange"
  >
    <woot-tabs-item
      v-for="(item, index) in items"
      :key="item.key"
      class="text-xs [&_a]:font-medium"
      :index="index"
      :name="item.name"
      :icon="item.icon"
      :count="item.count"
      :unread-count="item.unreadCount"
      is-compact
      :on-channel-surface="onChannelSurface"
      :accent-color="accentColor"
    />
  </woot-tabs>
</template>
